import React from 'react';
import { Col, Row, Container } from 'react-bootstrap/esm';
import { useAccount } from 'wagmi';
import { useLocation } from 'react-router-dom';
import { ethers } from 'ethers';
import HeaderOne from '../../components/header/HeaderOne';
import Footer from '../../components/footer/Footer';
import Breadcrumb from '../../components/teams/Breadcrumb';
import {
  getMyTeam,
  getTeam,
  getTeamPlayers,
  isLeader,
  isPlayerInTeam,
  joinTeam,
  leaveTeam,
} from '../../web3/SFM-TeamsUtils';
import { getImageUrlFromJson } from '../../utils/getImageUrlFromJson';
import SupportTeam from '../../components/teams/SupportTeam';
import OpenSeaLink from '../../components/sharedActions/openSeaLink';
import TwitterShare from '../../components/sharedActions/twitterShare';
import Loader from '../../components/Loader/loader';
import { toast } from 'react-hot-toast';
import TeamMembersArea from '../../components/teams/TeamMembersArea';

function SingleTeamPage() {
  const { isConnected, address } = useAccount();
  const search = useLocation().search;
  const queryParams = new URLSearchParams(search);
  const id = queryParams.get('id');
  const [isButtonClicked, setIsButtonClicked] = React.useState(false);
  const [team, setTeam] = React.useState();
  const [members, setMembers] = React.useState();
  const [isMyTeam, setIsMyTeam] = React.useState();

  const getSingleTeam = React.useCallback(async () => {
    try {
      const team = await getTeam(id);
      if (team) {
        let leaderurl = await getImageUrlFromJson(team.leaderURI);
        let memberurl = await getImageUrlFromJson(team.memberURI);
        let isLeaderFlag = await isLeader(address);
        setTeam({
          ...team,
          leaderImage: leaderurl,
          memberImage: memberurl,
          isLeader: isLeaderFlag,
        });
        const allMembers = await getTeamPlayers(id);
        const updatedMembers =
          allMembers &&
          allMembers
            .filter(
              ({ playerAddress }) =>
                playerAddress !== '0x0000000000000000000000000000000000000000'
            )
            .map((member) => ({
              ...member,
              image:
                member.playerAddress == team.leader ? leaderurl : memberurl,
              contractAddress:
                member.playerAddress == team.leader
                  ? process.env.REACT_APP_SFM_TEAM_CONTRACT_ADRESS
                  : process.env.REACT_APP_SFM_MEMBER_CONTRACT_ADRESS,
            }));
        allMembers && setMembers(updatedMembers);
      }
    } catch (e) {
      setTeam({});
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    if (isConnected) {
      getSingleTeam();
    }
  }, [getSingleTeam]);

  const getUserTeam = React.useCallback(async () => {
    try {
      const team = await getMyTeam();
      if (team && id == team?.id.toString()) {
        setIsMyTeam(true);
      } else {
        setIsMyTeam(false);
      }
    } catch (e) {
      setIsMyTeam(false);
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    if (isConnected) {
      getUserTeam();
    }
  }, [getUserTeam]);

  const requestJoinTeam = async () => {
    const hasTeam = await isPlayerInTeam();
    if (hasTeam) {
      toast.error('You already in a team');
    } else
      try {
        setIsButtonClicked(true);
        await joinTeam(parseInt(team.id)).then((e) => {
          console.log(e);

          team.requiresApproval
            ? toast.success(
                `you request to join ${team.name} team sent to team leader successfully`
              )
            : toast.success(`you joined ${team.name} team successfully`);
          setIsButtonClicked(false);
          window.location.reload();
        });
      } catch (e) {
        setIsButtonClicked(false);
        toast.error(e.message);
      }
  };
  const leaveYourTeam = async () => {
    try {
      setIsButtonClicked(true);
      await leaveTeam().then((e) => {
        console.log(e);

        toast.success(`you left ${team.name} team successfully`);
        setIsButtonClicked(false);
        window.location.reload();
      });
    } catch (e) {
      setIsButtonClicked(false);
      toast.error(e.message);
    }
  };

  return (
    <>
      <HeaderOne />
      <main>
        <Breadcrumb
          mainTitle={team && team.name}
          subTitle={team && team.description}
        />
        <div className="team-wrapper py-5 ">
          <Container>
            {team ? (
              Object.keys(team).length !== 0 ? (
                <>
                  <Row>
                    <Col lg={12} md={12} sm={12}>
                      <Row>
                        <Col>
                          <h2>{team.name}</h2>
                          <ul className="team-actions-list">
                            <li>
                              <SupportTeam
                                teamId={parseInt(team.id)}
                                teamName={team.name}
                              />
                            </li>
                            <li>
                              <OpenSeaLink
                                openseaLink={`${
                                  process.env.REACT_APP_OPENSEA_LINK
                                }/${
                                  process.env.REACT_APP_SFM_OPENSEA_NETWORK
                                }/${
                                  process.env
                                    .REACT_APP_SFM_MEMBER_CONTRACT_ADRESS
                                }/${team.memberTokenId.toString()}`}
                              />
                            </li>
                            <li>
                              <TwitterShare
                                tweetTitle={team.name}
                                tweetLink={`${
                                  window.location.origin
                                }/#/single-team?${parseInt(team.id)}`}
                              />
                            </li>
                          </ul>
                          <br />
                          <h4>
                            <strong>Balance: </strong>{' '}
                            {ethers.utils.formatEther(team.balance)}
                          </h4>
                          <h4>
                            <strong>Joining Fees: </strong>
                            {ethers.utils.formatEther(team.joiningFee)}
                          </h4>

                          <p>
                            <strong>Rules: </strong> {team.rules}
                          </p>
                          <p className="mb-5">
                            <strong>Description: </strong> {team.description}
                          </p>
                        </Col>
                        <Col>
                          <Row>
                            <Col>
                              <img src={team.memberImage} />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {address !== team.leader ||
                                (team.isleader && (
                                  <>
                                    <a
                                      onClick={() => {
                                        isMyTeam
                                          ? leaveYourTeam()
                                          : requestJoinTeam();
                                      }}
                                      className={`btn btn-style-two mt-5 ml-5 ${
                                        isMyTeam && 'btn-red'
                                      }`}
                                    >
                                      {isButtonClicked ? (
                                        <div className="lds-dual-ring"></div>
                                      ) : isMyTeam ? (
                                        'Leave'
                                      ) : (
                                        'Join'
                                      )}
                                    </a>
                                    <p className="mt-2 text-mutes">
                                      {team.requiresApproval &&
                                        'Joining Team Require Leader Approve'}
                                    </p>
                                  </>
                                ))}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {members ? (
                    members.length > 0 ? (
                      <TeamMembersArea
                        members={members}
                        team={{ name: team.name, id: id }}
                      />
                    ) : (
                      <h4 className="text-center text-light py-5">
                        No Members joined this team Yet
                      </h4>
                    )
                  ) : (
                    <div className="my-5">
                      <div className="row justify-content-center ">
                        <h4>Fetching team members Please wait...</h4>
                      </div>
                      <div className="row justify-content-center ">
                        <Loader />
                      </div>
                    </div>
                  )}
                  <Row>
                    <Col></Col>
                  </Row>
                </>
              ) : (
                <h4 className="text-center text-light py-5">No Team Yet</h4>
              )
            ) : (
              <div className="my-5">
                <div className="row justify-content-center ">
                  <h4>Fetching team Please wait...</h4>
                </div>
                <div className="row justify-content-center ">
                  <Loader />
                </div>
              </div>
            )}
          </Container>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default SingleTeamPage;
